import { getAuthAxiosBackend } from "../helpers/axios"

class AttachmentServices{

    constructor(){
    }

    get(id){
        return getAuthAxiosBackend().get( 'attachments' + '/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('attachments', {params: data})
    }

    add(attachment){
        return getAuthAxiosBackend().post('attachments', attachment)
    }

    edit(id, attachment){
        attachment.append('_method', 'put')
        return getAuthAxiosBackend().post('attachments' + '/' + id, attachment)
    }

    delete(id){
        return getAuthAxiosBackend().delete('attachments' + '/' + id)
    }
}

export default new AttachmentServices()